import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';

const MUIDatePicker = (props) => {

    return (
        <>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']} sx={{ overflow: 'unset', pt: '0px' }}>
                    <DatePicker
                        value={dayjs(props.value)}
                        onChange={(newValue) => {
                            //console.log("newValue", newValue);
                            props.setValue(newValue)
                        }}
                        // defaultValue={dayjs(props.value)}
                        disableFuture={props.disableFuture != undefined ? props.disableFuture : false}
                        disablePast={props.disablePast != undefined ? props.disablePast : false}
                        disabled={props.disabled != undefined ? props.disabled : false}
                        label={props.label ? (props.label + (props.required ? ' *' : '')) : ''}
                        slotProps={{
                            textField: {
                                size: 'small',
                                helperText: props.error,
                                error: props.error && props.error.length > 0 ? true : false,
                                readOnly: true,
                                style: props.width ? { minWidth: '150px' } : { minWidth: '100%' },
                            }
                        }}

                        minDate={props.minDate != undefined ? props.minDate : ''}
                        maxDate={props.maxDate != undefined ? props.maxDate : ''}

                        shouldDisableDate={props.disabledDates !== undefined && props.disabledDates.length > 0 ? (dateParam) => {
                            // Format the dateParam to match the format of the dates in the array
                            const dateString = dayjs(dateParam).format('YYYY-MM-DD');
                            let isDisabled = true; // Default to disabled unless a match is found
                            props.disabledDates.forEach((disabledDate) => {
                                if (dateString === dayjs(disabledDate).format('YYYY-MM-DD')) {
                                    isDisabled = false; // Date is in the array, so it should not be disabled
                                }
                            });

                            return isDisabled;
                        } : props.disableallDates ? () => true : () => false}


                    />
                </DemoContainer>
            </LocalizationProvider>
        </>
    );
};

export default MUIDatePicker;
